"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("react-app-polyfill/ie11");

require("react-app-polyfill/stable");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _searchUiSiteSearchConnector = _interopRequireDefault(require("@elastic/search-ui-site-search-connector"));

var _reactSearchUi = require("@elastic/react-search-ui");

var _searchBox = _interopRequireDefault(require("./search-box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Search = /*#__PURE__*/function (_React$Component) {
  _inherits(Search, _React$Component);

  var _super = _createSuper(Search);

  function Search() {
    _classCallCheck(this, Search);

    return _super.apply(this, arguments);
  }

  _createClass(Search, [{
    key: "render",
    value: function render() {
      var _this = this;

      var props = this.props;
      return /*#__PURE__*/_react.default.createElement(_reactSearchUi.SearchProvider, {
        config: {
          apiConnector: props.connector,
          initialState: {
            resultsPerPage: 10
          },
          trackUrlState: props.resultsOnly ? false : true,
          // do not push search query to URL if using resultsOnly
          searchQuery: {
            facets: {
              site: {
                type: 'value'
              }
            }
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_reactSearchUi.WithSearch, {
        mapContextToProps: function mapContextToProps(_ref) {
          var isLoading = _ref.isLoading,
              searchTerm = _ref.searchTerm,
              setSearchTerm = _ref.setSearchTerm,
              results = _ref.results,
              trackClickThrough = _ref.trackClickThrough,
              wasSearched = _ref.wasSearched,
              reset = _ref.reset;
          return {
            isLoading: isLoading,
            searchTerm: searchTerm,
            setSearchTerm: setSearchTerm,
            results: results,
            trackClickThrough: trackClickThrough,
            wasSearched: wasSearched,
            reset: reset
          };
        }
      }, function (_ref2) {
        var isLoading = _ref2.isLoading,
            searchTerm = _ref2.searchTerm,
            setSearchTerm = _ref2.setSearchTerm,
            results = _ref2.results,
            trackClickThrough = _ref2.trackClickThrough,
            wasSearched = _ref2.wasSearched,
            reset = _ref2.reset;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "".concat(_this.props.resultsOnly ? '' : 'h36 ', "relative")
        }, /*#__PURE__*/_react.default.createElement(_searchBox.default, {
          searchTerm: searchTerm,
          trackClickThrough: trackClickThrough,
          setSearchTerm: setSearchTerm,
          results: results,
          wasSearched: wasSearched,
          placeholder: props.placeholder,
          isLoading: isLoading,
          inputId: props.inputId,
          background: props.background,
          narrow: props.narrow,
          disableModal: props.disableModal || props.resultsOnly // disable modal if resultsOnly === true
          ,
          site: props.site,
          reset: reset,
          resultsOnly: props.resultsOnly,
          segmentTrackEvent: props.segmentTrackEvent,
          overrideSearchTerm: props.overrideSearchTerm,
          themeCompact: props.themeCompact,
          emptyResultMessage: props.emptyResultMessage
        }));
      }));
    }
  }]);

  return Search;
}(_react.default.Component);

Search.propTypes = {
  /** replace the input placehoder with a different string */
  placeholder: _propTypes.default.string,

  /** collapse input to fit in a crowded space */
  narrow: _propTypes.default.bool,
  //
  background: _propTypes.default.oneOf(['light', 'dark']),

  /** override default id for input/label, used for testing */
  inputId: _propTypes.default.string,

  /** disable modal if you always want an input */
  disableModal: _propTypes.default.bool,

  /** add current site filter toggle */
  site: _propTypes.default.string,

  /** option to connect to a custom search engine */
  connector: _propTypes.default.instanceOf(_searchUiSiteSearchConnector.default),

  /** If true, only show results from search */
  resultsOnly: _propTypes.default.bool,

  /** If `resultsOnly: true` set `overrideSearchTerm` to set the search term */
  overrideSearchTerm: _propTypes.default.string,

  /** Segment track event, default is (Searched docs) */
  segmentTrackEvent: _propTypes.default.string,

  /** If true, enable compact mode utilizing smaller text and padding, default false */
  themeCompact: _propTypes.default.bool,

  /** Node to display when there are no search results for the given query */
  emptyResultMessage: _propTypes.default.node
};
Search.defaultProps = {
  background: 'light',
  placeholder: 'Search docs.mapbox.com',
  inputId: 'docs-search',
  connector: new _searchUiSiteSearchConnector.default({
    engineKey: 'zpAwGSb8YMXtF9yDeS5K',
    // public engine key
    engineName: 'docs',
    documentType: ['page']
  }),
  resultsOnly: false,
  segmentTrackEvent: 'Searched docs',
  themeCompact: false,
  emptyResultMessage: /*#__PURE__*/_react.default.createElement("p", null, "Hmmm, we didn't find anything. Reword your search, or", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "https://support.mapbox.com/hc/en-us"
  }, "contact Support"), ".")
};
var _default = Search;
exports.default = _default;